module.exports = __webpack_public_path__ + "static/media/easy_work.3c728375.webp";